import React from 'react'
import styles from './Checkbox.module.css'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)

const Checkbox = props => (
  <div className={cx({
    base: true,
    isActive: props.checked,
  })}>
    <label>
      <div>
        <div className={styles.input}>
          <input
            type="checkbox"
            name={props.name}
            value={props.value}
            onChange={props.onChange} />
        </div>
      </div>
      <div>
        <div className={styles.label}><b>{props.value}.</b> {props.label}</div>
      </div>
    </label>
  </div>
)

export default Checkbox
